<div class="wrap">
  <app-header-home></app-header-home>
  <app-home-content></app-home-content>


  <div class="total_booked_close" id="total_booked" *ngIf="router.url === '/home/my-shopping-bag' && userConnected"
    (click)=" opendBasketDiv() ">
    <div class="content">
      <div class="total" *ngIf="!bookedOpen">
        <fa-icon [icon]="getFaIcon('faShoppingBasket')" appChangeColorTheme attribute="color"></fa-icon>
        <p>Confirmer et passer commande</p>
        <p><strong>{{ totalDiscount ? totalDiscount :totalPrice}} €</strong></p>
      </div>
      <fa-icon class="open_close_total" [icon]="bookedOpen? getFaIcon('faChevronDown'): getFaIcon('faChevronUp')">
      </fa-icon>

      <div class="offer_selected" *ngIf="bookedOpen">
        <div class="total">
          <fa-icon [icon]="getFaIcon('faShoppingBasket')" appChangeColorTheme attribute="color"></fa-icon>
          <p>Total des offres selectionnées <br> de mon panier</p>
        </div>
        <ul *ngIf="offerAddToPayment?.length">
          <ng-container *ngFor="let o of offerAddToPayment">


            <div class="list_item_offerAddToPayment" *ngIf="o?.isSelected"
              style="--numbOfItemInBasket:var(--numbOfItemInBasket){{offerAddToPayment?.length}}">
              <mat-checkbox [checked]="true" [color]="color" (click)="addToPayment(o)"></mat-checkbox>

              <li class="item_offerAddToPayment">
                <span class="label">{{o?.offerName}}</span>
                <span class="price" *ngIf="!o.isComplete"><strong> À perso.</strong></span>
                <span class="session_price"
                  *ngIf="o.isComplete && !o?.hasSession"><strong>{{o?.sessionTotalPrice}}€</strong></span>
              </li>
            </div>

            <div class="session" *ngIf="o?.isComplete && o?.isSelected && o.hasSession">

              <span class="session_label">
                <fa-icon [icon]="getFaIcon('faCalendarAlt')"></fa-icon>
                <ng-container *ngIf="o.hasSession">
                  {{getSessionOfferBasket(o)?.dateLib}} -
                  {{getSessionOfferBasket(o)?.sessionStartDate | date: "shortDate":'UTC'}}
                </ng-container>

              </span>
              <span class="session_price">{{o?.sessionTotalPrice}}€</span>
            </div>


          </ng-container>
          <li *ngIf="!noOfferInBasket().length" class="no_offer_to_perso">Aucune offre sélectionnée </li>

          <li *ngIf="basketWithPrice.promoCodeDiscount && basketWithPrice.promoCodeName" class="last_item">
            <span class="label">Code Promo <i>"{{basketWithPrice.promoCodeName}}"</i>
              <button type="button" matTooltip="Retirer le code promo" mat-icon-button color="primary"
                (click)="removePromoCode()">
                <fa-icon [icon]="getFaIcon('faTrashAlt')" appChangeColorTheme attribute="color"></fa-icon>
              </button></span>
            <span class="price"><strong>-{{basketWithPrice.promoCodeDiscount}}€</strong></span>
          </li>

          <div class="add_licence" *ngIf="licences?.length">
            <div class="licence_title">
              <h5 class="messageRed">L'ajout de licence(s) est automatique car l'un des participants n'a pas renseigné
                son n° de licence
              </h5>
              <!-- <span><strong>x{{licences?.length}}</strong></span> -->
            </div>

            <div class="licence_content">
              <div class="licence_item" *ngFor="let l of licences">
                <p>{{l.sessions[0].dateLib}}</p>
                <span><strong>{{l.sessionTotalPrice}}€</strong></span>
              </div>
            </div>
          </div>
          <li class="last_item last_item_first"><span class="label">Total</span> <span
              class="price"><strong>{{totalPrice}}€</strong></span>
          </li>
          <li class="last_item" *ngIf="totalDiscount"><span class="label">Total remisé</span> <span
              class="price"><strong>{{totalDiscount}}€</strong></span></li>
          <li class="last_item" *ngIf="basketWithPrice.grandDiscount > 0"><span class="label">Réduction supplémentaire
            </span> <span class="price"><strong>{{basketWithPrice.grandDiscount}}%</strong></span></li>
          <li class="last_item" *ngIf="basketWithPrice.grandDiscount > 0"><span class="label">Total remisé </span> <span
              class="price"><strong>{{basketWithPrice.discountedGrandTotal}}€</strong></span></li>
        </ul>
        <p *ngIf="!offerAddToPayment?.length" [style.margin-top.px]="10" class="no_offer_to_perso">Aucune offre </p>



        <div class="discount" *ngIf="activePromoCode">

          <h5>Code promo</h5>
          <form [formGroup]="discountForm" (ngSubmit)="applyPromoCode()">
            <mat-form-field appearance="outline">
              <mat-label>Appliquer un code promo</mat-label>
              <input matInput type="text" formControlName="promoCodeName" (click)="$event.stopPropagation()">
            </mat-form-field>
            <button mat-raised-button [color]="color" (click)="$event.stopPropagation()" type="submit">Valider</button>
          </form>

          <div class="message_discount" *ngIf="messageDiscount">{{messageDiscount}}</div>
        </div>

        <div *ngIf="offerAddToPayment?.length > 0" class="goBackClub" appChangeColorTheme attribute="bgc"
          (click)="goHome()">
          Continuer les achats d'offres du club
        </div>

        <div class="cgv" *ngIf="!isLoadingCGV">
          <mat-checkbox [color]="color" *ngIf="offerAddToPayment?.length"
            (click)="acceptCGV(); $event.stopPropagation()">
            J'accepte
            <!-- <a (click)="$event.stopPropagation(); downloadCGV()" href="">les conditions générales du club</a> -->
          </mat-checkbox>
          <span style="text-decoration: underline;" (click)="$event.stopPropagation(); downloadCGV()"
            appChangeColorTheme attribute="color"> les conditions générales de vente </span>
        </div>

        <mat-spinner style="margin: 0 auto 10px auto;" *ngIf="isLoadingCGV" diameter="30"></mat-spinner>

        <div
          [ngClass]="{payment_active: allMyOffersIsComplete(), payment_deactive: (!allMyOffersIsComplete() || !offerAddToPayment?.length)}"
          (click)="allMyOffersIsComplete()? bookOffer(): null; $event.stopPropagation() ">
          <ng-container *ngIf="authoToClick">
            <fa-icon [icon]="getFaIcon('faLock')"></fa-icon>
            {{ offerAddToPayment?.length <= 1?'Passer commande' : 'Passer commande' }} </ng-container>
              <div class="spinner_confirm_basket" *ngIf="!authoToClick">
                <mat-spinner [diameter]="20"></mat-spinner>
              </div>

        </div>

        <div class="pdf_basket" appChangeColorTheme attribute="bgc" (click)="getPdfBasket(); $event.stopPropagation()">
          <fa-icon [icon]="getFaIcon('faFilePdf')"></fa-icon>
          Exporter mon devis
        </div>




        <p *ngIf="getOffertoPersoNoComplete()?.length > 0" class="message_for_valid">Il vous reste
          <strong>{{getOffertoPersoNoComplete()?.length}}</strong>
          {{getOffertoPersoNoComplete()?.length > 1? 'offres' : 'offre'}} à paramétrer pour valider
        </p>

      </div>
    </div>
  </div>

</div>